<template>
    <generic-task-execution-modal
        :asset="asset"
        :assignable-users="assignableUsers"
        :description="description"
        :form="form"
        :task-resolved="taskResolved"
        :primary-button-label="primaryButtonLabel"
        :editable="editable"
        :task-code="taskCode"
        :task-group="taskGroup"
        :task-id="taskId"
        :title="title"
        @submit="handleSubmit"
    >
        <location-form-fields v-model="form.location_id" :disabled="!editable" :inline="true" :location-tree="locationTree" />
    </generic-task-execution-modal>
</template>
<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n';
import LocationFormFields from '@/Pages/Assets/Edit/LocationFormFields.vue';
const GenericTaskExecutionModal = defineAsyncComponent(() => import('@/Pages/Modals/GenericTaskExecutionModal.vue'));

const props = defineProps({
    asset: {
        type: Object,
        required: true,
    },
    locationTree: {
        type: Object,
        required: true,
    },
    currentUserId: String,
    title: String,
    description: String,
    taskId: String,
    taskCode: String,
    taskGroup: String,
    taskType: String,
    assetId: String,
    editable: Boolean,
    assignableUsers: Object,
    links: Object,
    existingLocationId: String,
    existingDescription: String,
    existingPerformedById: String,
    taskResolved: { type: Boolean, default: false },
});

const form = useForm({
    asset_id: props.asset.id,
    location_id: props.existingLocationId ?? props.asset.location.id,
    performedById: props.existingPerformedById ?? props.currentUserId,
    taskId: props.taskId,
    task_type: props.taskType,
    description: props.existingDescription ?? null,
    attachments: [],
});

const hasLocationChanged = computed(() => form.location_id !== props.asset.location.id);
const primaryButtonLabel = computed(() => {
    if (props.taskResolved) {
        return trans('tasks.modal.awaiting_approval.save_changes');
    }
    return hasLocationChanged.value ? trans('general.action.update') : trans('general.action.confirm');
});

const handleSubmit = (modal) => {
    form.post(props.links.create, {
        preserveScroll: true,
        onSuccess: () => {
            modal.emit('created', {
                assetId: props.asset.id,
                ...form.data(),
            });

            modal.close();
        },
    });
};
</script>
